// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7 2H17V5H20V9H4V5H7V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 13V11H2V13H3V20H2V22H8V16H16V22H22V20H21V13H22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14 22H10V18H14V22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-building-filled')
export default class BuildingFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building-filled',
    }
  }
}
